// SOS live-location public API base — production since 24 Oct. Keep in sync
// with the edge Worker (cloudflare/worker.js), which holds its own copy.
export const SOS_API_BASE = "https://api.nischint.care";

// /plans checkout switch. false (committed): plan CTAs open the waitlist form
// pre-tagged with plan_interest instead of Razorpay. The Razorpay dialog and
// its /api/payments/subscriptions flow stay in the codebase behind this flag
// — flip to true to re-enable live checkout. Do not delete the Razorpay code.
export const CHECKOUT_ENABLED = false;

// Site-wide external links — single source of truth.
// The Foundation domain changes to nischintseva.org later; update it here only.
export const VOLUNTEER_URL = "https://nischintsewa.org/volunteer";

// /kids page availability switches (per KIDS_PAGE_COPY.md build spec):
// KIDS_STATUS: 'waitlist' (default until counsel approves the parental consent
//   method) | 'live'
// KIDS_DEVICES_STATUS: 'coming_soon' (default) | 'available'
// KIDS_IMAGES_READY: flip to true only when /public/images/kids/case-01..10.png
//   and og-kids.jpg are in place — the gate in scripts/prerender-meta.mjs
//   fails the build otherwise, so placeholders can never reach production.
export const KIDS_STATUS = "waitlist";
export const KIDS_DEVICES_STATUS = "coming_soon";
export const KIDS_IMAGES_READY = true;
// LEGAL GATE: /kids ships (route, nav link, sitemap, prerender) ONLY when
// KIDS_IMAGES_READY && KIDS_PAGE_APPROVED are both true. Committed false
// until counsel signs off on the kids page — images being in the repo no
// longer means a deploy publishes /kids.
export const KIDS_PAGE_APPROVED = false;
// Local evidence override (never set in a publish environment): exercises
// the approved state without touching the committed flags. Node prerender
// reads KIDS_APPROVED_LOCAL=1, the client bundle REACT_APP_KIDS_APPROVED_LOCAL=1.
const KIDS_APPROVED_LOCAL =
  process.env.KIDS_APPROVED_LOCAL === "1" ||
  process.env.REACT_APP_KIDS_APPROVED_LOCAL === "1";
export const KIDS_PUBLISHABLE =
  KIDS_IMAGES_READY && (KIDS_PAGE_APPROVED || KIDS_APPROVED_LOCAL);
// Route/nav registration for /kids. Production: only when publishable.
// Local placeholder evidence builds opt in with REACT_APP_ALLOW_KIDS_PLACEHOLDERS=1
// (mirrors ALLOW_KIDS_PLACEHOLDERS for the node-side prerender gate).
export const KIDS_ROUTE_ENABLED =
  KIDS_PUBLISHABLE || process.env.REACT_APP_ALLOW_KIDS_PLACEHOLDERS === "1";
